import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/app/(app)/academy/videos/[slug]/components/Chapters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SuccessfulPurchase"] */ "/home/will/Documents/Business/wise/repos/wise/site/app/(app)/academy/videos/[slug]/components/SuccessfulPurhcase.tsx");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/domains/about/images/raypoynter.webp");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/domains/about/images/willpoynter.webp");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/domains/layout/components/StyledText.module.css");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/domains/layout/components/StyledText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PodcastMuxPlayer"] */ "/home/will/Documents/Business/wise/repos/wise/site/domains/podcasts/components/PodcastMuxPlayer.tsx");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/domains/videos/components/VideoWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/products/academy/talking-ai/images/amazon-music.svg");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/products/academy/talking-ai/images/apple-podcasts.svg");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/products/academy/talking-ai/images/castbox-badge-light.svg");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/products/academy/talking-ai/images/linkedin-share-button-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/products/academy/talking-ai/images/pocketcasts-dark.svg");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/products/academy/talking-ai/images/reddit-share-button-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/products/academy/talking-ai/images/spotify-podcast-badge-blk-grn.svg");
